import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import usePortal from '../../hooks/usePortal';
import apis from '../../helpers/apis';
import { useSelector } from 'react-redux';
import Overlay from './Overlay';

const OverlayPortal = () => {
    const target = usePortal('modal-root');
    const [overlayData, setOverlayData] = useState(null);
    const { isVisible, screen } = useSelector((state) => state.overlay);

    useEffect(() => {
        if (isVisible) {
            apis.getCmsService()
                .screens()
                .getScreen(screen)
                .then((data) => {
                    setOverlayData(data);
                });
        }
    }, [isVisible]);

    return (
        isVisible &&
        createPortal(
            <Overlay isLoading={overlayData === null}>
                {/* {overlayData && <PageComponentsMapper pageComponents={overlayData.components} screenKey={screen} />} */}
            </Overlay>,
            target
        )
    );
};

export default OverlayPortal;
